import { render, staticRenderFns } from "./blurb-content-for-ngo.html?vue&type=template&id=66020859&scoped=true&external"
import script from "./blurb-content-for-ngo.js?vue&type=script&lang=js&external"
export * from "./blurb-content-for-ngo.js?vue&type=script&lang=js&external"
import style0 from "./blurb-content-for-ngo.scss?vue&type=style&index=0&id=66020859&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66020859",
  null
  
)

export default component.exports